import hres80xLabels from 'assets/labels/hres80x'

export const mocker = {
  labels () {
    return {
      labels: hres80xLabels
    }
  },
  hisHeal () {
    return {
      'thisheal': {
        'status': '200',
        'data': {
          'coderror': '200',
          'desc_coderror': ' ',
          'httpcode': ' ',
          'flg': ' ',
          'flgheal1': '0',
          'remark1': 'TTT',
          'flgheal2': '0',
          'remark2': 'RRR',
          'flgheal3': '1',
          'remark3': 'EEE',
          'flgheal4': '1',
          'remark4': 'XXX',
          'flgheal5': '0',
          'remark5': 'HHJ',
          'flgheal6': '0',
          'remark6': 'AAA',
          'flgheal7': '0',
          'remark7': 'MMM',
          'flgheal8': '2',
          'qtysmok': '',
          'qtyyear': '0',
          'qtymth': '6',
          'qtysmok2': '5',
          'flgheal9': '5',
          'qtyyear9': '3',
          'qtymth9': '4',
          'desnote': 'กระเพราะไม่ดีเป้นโรคกระเพราะบ่อยและลำไส้อักเสบบ่อย'
        }
      },
      'thisheald': {
        'status': '200',
        'data': {
          'total': '2',
          'rows': [
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '2',
              'rcnt': '1',
              'numseq': '1',
              'dessick': 'ไข้หวัดใหญ่',
              'dteyear': '2558'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '2',
              'rcnt': '2',
              'numseq': '2',
              'dessick': 'ไซนัส',
              'dteyear': '2559'
            }
          ]
        }
      },
      'thishealf': {
        'status': '200',
        'data': {
          'total': '2',
          'rows': [
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '2',
              'rcnt': '1',
              'numseq': '1',
              'desrelat': 'ตา',
              'dessick': 'มะเร็งปอด'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '2',
              'rcnt': '2',
              'numseq': '2',
              'desrelat': 'ยาย',
              'dessick': 'เบาหวาน'
            }
          ]
        }
      },
      'thealinf': {
        'status': '200',
        'data': {
          'total': '20',
          'rows': [
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '1',
              'dteyear': '2017',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0001',
              'desc_codchkhl': 'ตรวจเลือด',
              'descheck': '100',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '2',
              'dteyear': '2017',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0002',
              'desc_codchkhl': 'ตรวจหัวใจ',
              'descheck': '100',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '3',
              'dteyear': '2017',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0004',
              'desc_codchkhl': 'ตรวจไขมันในเลือด',
              'descheck': '100',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '4',
              'dteyear': '2017',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0005',
              'desc_codchkhl': 'ตรวจ PH+',
              'descheck': '100',
              'chkresul': 'ผิดปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '5',
              'dteyear': '2017',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0006',
              'desc_codchkhl': 'ตรวจทั่วไป',
              'descheck': '100',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '6',
              'dteyear': '2016',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0001',
              'desc_codchkhl': 'ตรวจเลือด',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '7',
              'dteyear': '2016',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0002',
              'desc_codchkhl': 'ตรวจหัวใจ',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '8',
              'dteyear': '2016',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0004',
              'desc_codchkhl': 'ตรวจไขมันในเลือด',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '9',
              'dteyear': '2016',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0005',
              'desc_codchkhl': 'ตรวจ PH+',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '10',
              'dteyear': '2016',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0006',
              'desc_codchkhl': 'ตรวจทั่วไป',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '11',
              'dteyear': '2015',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0001',
              'desc_codchkhl': 'ตรวจเลือด',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '12',
              'dteyear': '2015',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0002',
              'desc_codchkhl': 'ตรวจหัวใจ',
              'descheck': '60',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '13',
              'dteyear': '2015',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0004',
              'desc_codchkhl': 'ตรวจไขมันในเลือด',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '14',
              'dteyear': '2015',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0005',
              'desc_codchkhl': 'ตรวจ PH+',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '15',
              'dteyear': '2015',
              'codheal': '4000',
              'desc_codheal': 'ตรวจสุขภาพประจำปี',
              'codcln': '15',
              'codchkhl': '0006',
              'desc_codchkhl': 'ตรวจทั่วไป',
              'descheck': '80',
              'chkresul': 'ปกติ',
              'typheal': '2',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '16',
              'dteyear': '2016',
              'codheal': '1000',
              'desc_codheal': 'ตรวจสุขภาพก่อนเริ่มงาน',
              'codcln': '15',
              'codchkhl': '0001',
              'desc_codchkhl': 'ตรวจเลือด',
              'descheck': '250',
              'chkresul': 'ปกติ',
              'typheal': '1',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '17',
              'dteyear': '2016',
              'codheal': '1000',
              'desc_codheal': 'ตรวจสุขภาพก่อนเริ่มงาน',
              'codcln': '15',
              'codchkhl': '0002',
              'desc_codchkhl': 'ตรวจหัวใจ',
              'descheck': '250',
              'chkresul': 'ปกติ',
              'typheal': '1',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '18',
              'dteyear': '2016',
              'codheal': '1000',
              'desc_codheal': 'ตรวจสุขภาพก่อนเริ่มงาน',
              'codcln': '15',
              'codchkhl': '0005',
              'desc_codchkhl': 'ตรวจ PH+',
              'descheck': '250',
              'chkresul': 'ปกติ',
              'typheal': '1',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '19',
              'dteyear': '2016',
              'codheal': '1000',
              'desc_codheal': 'ตรวจสุขภาพก่อนเริ่มงาน',
              'codcln': '15',
              'codchkhl': '0006',
              'desc_codchkhl': 'ตรวจทั่วไป',
              'descheck': '250',
              'chkresul': 'ปกติ',
              'typheal': '1',
              'dteheal': '19/08/2017'
            },
            {
              'coderror': '200',
              'desc_coderror': ' ',
              'httpcode': ' ',
              'flg': ' ',
              'total': '20',
              'rcnt': '20',
              'dteyear': '2016',
              'codheal': '1000',
              'desc_codheal': 'ตรวจสุขภาพก่อนเริ่มงาน',
              'codcln': '15',
              'codchkhl': '0009',
              'desc_codchkhl': 'LDL',
              'descheck': '250',
              'chkresul': 'ปกติ',
              'typheal': '1',
              'dteheal': '19/08/2017'
            }
          ]
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hres80x/mocker.js